import React from 'react';

export const AppContext = React.createContext({
  role: '',
  isStaff: false,
  firstName: '',
  lastName: '',
  email: '',
});
